module.exports = __webpack_public_path__ + "img/gt.dc030ab6.png";